import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ReferenceRange from './referenceRange';
import { referenceType as referenceTypeConstant } from '../../../shared/constants';
import { selectInRange } from '../../../shared/actions/references';

const mapStateToProps = (state) => {
  const { references } = state;
  const currentlyViewedIndex = references.rangeIndex;
  return { currentlyViewedIndex };
};

const mapDispatchToProps = (dispatch, { referenceType }) => ({
  selectInRange: index => dispatch(selectInRange(referenceType, index)),
});

const ReferenceRangeContainer = connect(mapStateToProps, mapDispatchToProps)(ReferenceRange);

ReferenceRangeContainer.propTypes = {
  referenceType: PropTypes.oneOf(Object.values(referenceTypeConstant)).isRequired,
};

export default ReferenceRangeContainer;
